import type {FormSortType} from 'nutshell-graphql-types';
import type {GetFormsVariables as GetFormsQueryVariables} from 'nutshell-graphql-types';

export const DEFAULT_FORM_LIST_LIMIT = 20;

export function getFormListQueryVariables(
    isArchived: boolean,
    sort: FormSortType,
    search?: string | null,
    limit?: number | null,
    creatorUserId?: string | null,
    lastUpdatedTime?: string | null
): GetFormsQueryVariables {
    return {
        archived: isArchived,
        sort,
        search,
        limit: limit ? limit : DEFAULT_FORM_LIST_LIMIT,
        creatorUserId,
        lastUpdatedTime,
    };
}
